
<template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <h2 class="inter-titre">Archives actualités</h2>
                <section class="sectionFiltres">
                    <div class="filtres">  
                        <div>
                            <svg @click="openFiltres = ! openFiltres" xmlns="http://www.w3.org/2000/svg" width="33" height="30" viewBox="0 0 33 30">
                                <path id="Icon_feather-filter" data-name="Icon feather-filter" d="M33,4.5H3L15,18.69V28.5l6,3V18.69Z" transform="translate(-1.5 -3)" fill="none" stroke="#0F2D93" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                            </svg>
                        </div>
                        <h4 >{{listeActualitesAnte.length}} actualités</h4>
                    </div>
                    <div class="FiltresTris ordi" v-show="openFiltres">
                        <div class="menu-filtres">
                            <div class="input-recherche loupe">
                                <svg xmlns="http://www.w3.org/2000/svg" width="35.997" height="36.004" viewBox="0 0 35.997 36.004">
                                    <path id="Icon_awesome-search" data-name="Icon awesome-search" d="M35.508,31.127l-7.01-7.01a1.686,1.686,0,0,0-1.2-.492H26.156a14.618,14.618,0,1,0-2.531,2.531V27.3a1.686,1.686,0,0,0,.492,1.2l7.01,7.01a1.681,1.681,0,0,0,2.384,0l1.99-1.99a1.7,1.7,0,0,0,.007-2.391Zm-20.883-7.5a9,9,0,1,1,9-9A8.995,8.995,0,0,1,14.625,23.625Z" fill="#0F2D93"/>
                                </svg>
                                <input type="text" v-model="keyword" placeholder="Recherche par mots clé">                                      
                            </div>
                        
                            <div class="input-recherche listeAlbums" >
                                <h4>Correspondant à la recherche : {{filterListPubliAnte.length}}</h4>
                            </div>

                            <div class="input-recherche datePubli">
                                <i class="input-date">Début</i>
                                <input type="date" v-model="dateMin">
                                <i class="input-date">Fin</i>
                                <input type="date" :max="DateMaxEN" v-model="dateMax">
                            </div>
                        </div>
                        <div class="menu-classification">
                            <div class="menu-classification">
                                <h4 class="h4gauche"></h4>
                            </div>
                            
                            <div class="menu-classification">
                                <h4 class="h4droite">Trier par</h4>
                            </div>
                        </div>
                        <div class="menu-classification">
                            <div class="menu-classification affichage boutons-affichage">
                                <div class="button-classification buttonReini ButtonOuvertureFiltre" @click="ReiniFiltres()" id="buttonReini">
                                    <h4 class="ButtonOuvertureFiltre">Réinitialiser les filtres</h4> 
                                </div>
                            </div>
                            <div class="menu-classification">
                                
                            </div>
                            <div class="menu-classification Tri boutons-tris">
                                <div class="input-recherche listeAlbums" id="buttonDateAlbums">
                                    <select v-model="OrderActu">
                                        <option value="DateDecroissant">Du plus récent au plus ancien</option>
                                        <option value="DateCroissant">Du plus ancien au plus récent</option>
                                        <option value="NomCroissant">De A à Z</option>
                                        <option value="NomDecroissant">De Z à A</option>
                                    </select>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="Blue-fill" width="36" height="36" viewBox="0 0 36 36">
                                        <path id="Icon_open-sort-descending" data-name="Icon open-sort-descending" d="M9,0V27H0l11.25,9L22.5,27h-9V0Zm9,0V4.5H36V0Zm0,9v4.5H31.5V9Zm0,9v4.5h9V18Z"/>
                                    </svg>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </section>
                <section class="Section-pages section-pages-cartes">
                    <router-link :to="{name: 'Publication', params: {id : actualite.id}}" class="carte-conseiller" v-for="actualite in filterListPubliAnte" :key="actualite.id">
                        <div v-if="actualite.image != ''">
                            <img :src="actualite.image" class="portrait-conseiller">
                        </div>

                        <section class="contenu-carte">
                            <h5>{{actualite.titre}}</h5>
                            <i>{{actualite.date}} <br> </i>
                            <p v-html="actualite.textereduit"></p>
                        </section>
                    </router-link>
                </section>
                <div v-if="filterListPubliAnte.length == 0">
                    <p class="red" style="text-align: center">Aucune ancienne actualité ne correspondant à votre recherche n'a été trouvée. Merci de modifier vos critères de recherches.</p>
                </div>

                <h3 class="inter-titre" style="text-align: left">Échos de Quenne Nangis</h3>
                <section class="section-carte-scroll" v-if="EQNOrderByDate.length > 0">
                    <div v-for="Echo in EQNOrderByDate" :key="Echo.id">
                        <div v-if="Echo.date_comparaison > dateAncienneNumUn"> 
                            <h6 style="text-align: center;">{{Echo.date_fr}}</h6>
                            <div class="carte-conseiller">
                                <iframe :src="Echo.fichier_pdf" height="100%" width="100%"></iframe>
                            </div>
                            <br>
                            <br>
                            <div class="button">
                                <a  :href="Echo.fichier_pdf" target="_blank">Ouvrir le document</a>
                            </div>
                        </div>
                    </div> 
                </section>
                <section v-if="EQNOrderByDate.length < 1" >
                    <h6 style="text-align: center">Aucun Échos datant d'avant le {{dateAncienneAffMUn}} n'est disponible actuellement.</h6>
                    <br>
                    <br>
                    <div class="button">
                        <router-link  to="/infos-municipales">Voir les Échos de Quenne actuels</router-link>
                    </div>
                </section>

                <h3 class="inter-titre"  style="text-align: left">Listes des délibérations</h3>
                <section class="section-carte-scroll">
                    <div v-for="listedeliberation in listeDeliberations" :key="listedeliberation.id">
                        <h6 style="text-align: center;">{{listedeliberation.date}}</h6>
                        <div class="carte-conseiller">
                            <iframe :src="listedeliberation.fichier_pdf" height="100%" width="100%"></iframe>
                        </div>
                        <br>
                        <br>
                        <div class="button">
                            <a  :href="listedeliberation.fichier_pdf" target="_blank">Ouvrir le document</a>
                        </div>
                        <br>
                        <br>
                        <!-- <div class="button">
                            <router-link :to="{name: 'ListeDeliberations', params: {id : listedeliberation.id}}">Voir les délibérations</router-link>
                        </div> -->
                    </div>
                </section>
                <section v-if="listeDeliberations.length < 1" >
                    <h6 style="text-align: center">Aucune liste de délibérations datant d'avant le {{dateAncienneAffMUn}} n'est disponible actuellement.</h6>
                    <br>
                    <br>
                    <div class="button">
                        <router-link  to="/infos-municipales">Voir les listes de délibérations</router-link>
                    </div>
                </section>
                

                <h3 class="inter-titre" style="text-align: left">Comptes-rendus municipaux</h3>
                <section class="section-carte-scroll">
                    <div v-for="CRM in CRCMOrderByDate" :key="CRM.id">
                        <div> 
                            <h6 style="text-align: center;">{{CRM.date}}</h6>
                            <div class="carte-conseiller">
                                <div>
                                    <iframe :src="CRM.fichier_pdf" height="100%" width="100%"></iframe>
                                </div>
                            </div>
                            <br>
                            <br>
                            <div class="button">
                                <a  :href="CRM.fichier_pdf" target="_blank">Ouvrir le document</a>
                            </div>
                        </div>
                    </div> 
                </section>
                <section v-if="CRCMOrderByDate.length < 1">
                    <h6 style="text-align: center">Aucun Comptes-rendus municipaux datant d'avant le {{dateAncienneAffMUn}} n'est disponible actuellement.</h6>
                    <br>
                    <br>
                    <div class="button">
                        <router-link  to="/infos-municipales">Voir les Quenne Infos actuelles</router-link>
                    </div>
                </section>

                <h3 class="inter-titre" style="text-align: left">Quenne informations</h3>
                <section class="section-carte-scroll" v-if="listeQI.length > 0">
                    <div v-for="quenneInfo in listeQI" :key="quenneInfo.id">
                        <div> 
                            <h6 style="text-align: center;">{{quenneInfo.date_fr}}</h6>
                            <div class="carte-conseiller">
                                <div>
                                    <iframe :src="quenneInfo.fichier_pdf" height="100%" width="100%"></iframe>
                                </div>
                            </div>
                            <br>
                            <br>
                            <div class="button">
                                <a  :href="quenneInfo.fichier_pdf" target="_blank">Ouvrir le document</a>
                            </div>
                        </div>
                    </div> 
                </section>
                <section v-if="listeQI.length < 1">
                    <h6 style="text-align: center">Aucune Quenne Info datant d'avant le {{dateAncienneAffMUn}} n'est disponible actuellement.</h6>
                    <br>
                    <br>
                    <div class="button">
                        <router-link  to="/infos-municipales">Voir les Quenne Infos actuelles</router-link>
                    </div>
                </section>
            </section>
            
        </div>
    </div>
</template>

<script>


import param from '@/param/param'

export default {
    name: 'Publications',
    data () {
        return{
            listeQuenneInfos:[],
            listeActualites:[],
            listeActualitesAnte:[],
            listeComptesRendus:[],
            ActuFilterByDate: [],
            openFiltres: true,
            keyword: '',
            AlbumSelected: 0,
            dateMin: null,
            dateMax : null,
            dateAncienneNum: null,
            dateAncienneNumUn: null,
            range: 0,
            OrderActu: 'DateDecroissant',
            AlbumSelected: 0,
            CetAlbum: 0,
            vieilleActus: 0,
            NbrActus: 0,
            imageCourante: 'https://mairie-quenne./wp-content/uploads/2022/04/Quenne_C_FT.png',
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            },
            listeDeliberations: [],
            listeDeliberationsAnciens: [],
            dateAncienneAffMUn: '01/01/1979'
        }

    }, 

    created(){
        var currentdate = new Date();
        var date = new Date;
        var annee = date.getFullYear();
        var moi = date.getMonth();
        var mois = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
        var moisnumerique = new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12');

        var j = date.getDate();
        if(j < 10){
            j = '0'+j
        }
        var jour = date.getDay();
        var jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
        this.date = jours[jour]+' '+j+' '+mois[moi]+' '+annee+'';
        this.time = currentdate.getHours()+" h "+currentdate.getMinutes()+" min "+currentdate.getSeconds()+" sec";
        this.joursemaine = jours[jour];
        this.datejour = +j+'/'+moi;
        this.dateJourNum = j+'/'+moisnumerique[moi]+'/'+annee;
        this.DateMaxEN = annee+'-'+moisnumerique[moi]+'-'+j;
        this.jourInfini = mois[moi];
        this.anneeMUn = annee - 1
        this.anneePUn = annee + 1
        this.anneeMTrois = annee - 3
        this.dateAncienneNumUn = this.anneeMUn+'-'+moisnumerique[moi]+'-'+j;
        this.dateAncienneAffMUn = j+'/'+moisnumerique[moi]+'/'+this.anneeMUn
        this.dateAncienneNumUnCompa = this.anneeMUn+moisnumerique[moi]+j;
        this.dateAncienneNum = this.anneeMTrois+'-'+moisnumerique[moi]+'-'+j;
        this.dateFutureNum = annee+'-'+moisnumerique[moi]+'-'+j;

        this.dateMin = this.dateAncienneNum;
        this.dateMax = this.dateFutureNum

        


        axios.get(param.host+'quenneInfo/v1/listeQuenneInfos')
        .then(response =>{
            this.listeQuenneInfos = response.data;
            let Echos = new Array;
            let QI = new Array;
            let r = 0;
            let s = 0;
            for(var k = 0; this.listeQuenneInfos.length > k; k++){
                this.dateSplit = this.listeQuenneInfos[k].date.split('/');
                this.listeQuenneInfos[k].date_fr = this.dateSplit[1]+'/'+this.dateSplit[0]+'/'+this.dateSplit[2];
                this.listeQuenneInfos[k].date_comparaison = this.dateSplit[2]+this.dateSplit[0]+this.dateSplit[1];
                if(this.listeQuenneInfos[k].type == 'Échos de Quenne'){
                    Echos[r] = this.listeQuenneInfos[k];
                    r++;
                }if(this.listeQuenneInfos[k].type == 'Quenne informations'){
                    QI[s] = this.listeQuenneInfos[k];
                    s++;
                }
            }

            function compare(a, b){
                if(a.date_comparaison > b.date_comparaison) return -1
                if(a.date_comparaison < b.date_comparaison) return 1
                return 0
            }

            this.listeEchos = Echos.sort(compare)
            this.listeQI = QI.sort(compare)

        })
        .catch(error => console.log(error))

        axios.get(param.host+'actualite/v1/listeActualites')
        .then(response =>{
            this.listeActualites = response.data;
            let actu = new Array
            let actuAnte = new Array
            let j = 0
            let l = 0

            for(var k = 0; this.listeActualites.length > k; k++){
                this.dateSplit = this.listeActualites[k].date.split('/');
                this.listeActualites[k].date_comparaison = this.dateSplit[2]+'-'+this.dateSplit[1]+'-'+this.dateSplit[0];
                
                this.listeActualites[k].textereduit = this.listeActualites[k].texte.substring(0, 150) + '...';
                if(this.listeActualites[k].date_comparaison >= this.DateMaxEN){
                    actu[j] = this.listeActualites[k]
                    j++;
                }else{
                    actuAnte[l] = this.listeActualites[k]
                    l++;
                }

            }
            this.listeActualitesFuture = actu;
            this.listeActualitesAnte = actuAnte;

            function compare(a, b){
                if(a.date_comparaison < b.date_comparaison) return -1
                if(a.date_comparaison > b.date_comparaison) return 1
                return 0
            }

            this.listeActualitesFuture = actu.sort(compare)

        })
        .catch(error => console.log(error))

        axios.get(param.host+'compterendu/v1/listeComptesRendus')
        .then(response =>{
            this.listeComptesRendus = response.data;

            for(var j = 0; this.listeComptesRendus.length > j; j++){
                this.dateSplitCRM = this.listeComptesRendus[j].date.split('/');
                this.listeComptesRendus[j].date_comparaison_crm = this.dateSplitCRM[2]+ this.dateSplitCRM[1]+ this.dateSplitCRM[0];
            }
        })
        .catch(error => console.log(error))


        axios.get(param.host+'listeDeliberations/v1/listeListeDeliberations')
        .then(response =>{
            this.listeDeliberations = response.data;

            let CRM = new Array;
            let CRMRecent = new Array;
            var i = 0;
            var k = 0;

            for(var j = 0; this.listeDeliberations.length > j; j++){
                this.dateSplitCRM = this.listeDeliberations[j].date.split('/');
                this.listeDeliberations[j].date_comparaison_crm = this.dateSplitCRM[2]+this.dateSplitCRM[1]+this.dateSplitCRM[0];
                this.listeComptesRendus[j].date = this.dateSplitCRM[1]+'/'+ this.dateSplitCRM[0]+'/'+this.dateSplitCRM[2];

            }
        })
        .catch(error => console.log(error))
        
        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Archives'){
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },

    computed:{
        filterListPubliAnte: function(){
            return this.filterActuByRange(this.filterListByKeyword(this.ActusOrderByName))
        },


        ActusOrderByName: function(){
            if(this.listeActualitesAnte.length > 0){
                if(this.OrderActu == 'NomCroissant'){
                    function compare(a, b){
                        if(a.slug < b.slug) return -1
                        if(a.slug > b.slug) return 1
                        return 0
                    }
                    return this.listeActualitesAnte.sort(compare)
                }if(this.OrderActu =='NomDecroissant'){
                    function compare(a, b){
                        if(a.slug > b.slug) return -1
                        if(a.slug < b.slug) return 1
                        return 0
                    }
                    return this.listeActualitesAnte.sort(compare)
                }if(this.OrderActu == "DateDecroissant"){
                    function compare(a, b){
                        if(a.date_comparaison > b.date_comparaison) return -1
                        if(a.date_comparaison < b.date_comparaison) return 1
                        return 0
                    }
                    return this.listeActualitesAnte.sort(compare)
                }if(this.OrderActu == "DateCroissant"){
                    function compare(a, b){
                        if(a.date_comparaison < b.date_comparaison) return -1
                        if(a.date_comparaison > b.date_comparaison) return 1
                        return 0
                    }
                    return this.listeActualitesAnte.sort(compare)
                }else{
                    return this.listeActualitesAnte
                }
            }else{
                return this.listeActualitesAnte = ''
            }
            
        },

        CRCMOrderByDate: function(){
            function compare(a, b){
                if(a.date_comparaison_crm > b.date_comparaison_crm) return -1
                if(a.date_comparaison_crm < b.date_comparaison_crm) return 1
                return 0    
            }
            if(this.listeComptesRendus.length > 0){
                return this.listeComptesRendus.sort(compare)
            }else{
                return this.listeComptesRendus = ''
            }
        },

        EQNOrderByDate: function(){
            function compare(a, b){
                if(a.date_comparaison_crm > b.date_comparaison_crm){
                    return -1
                }else if(a.date_comparaison_crm < b.date_comparaison_crm){
                    return 1
                }return 0
            }
            if(this.listeEchos.length > 0){
                return this.listeEchos.sort(compare)
            }else{
                return this.listeEchos = ''
            }
        },

        CRCMDate: function(){
            
            this.anneeDernier = this.CRCMOrderByDate[0].date.split('/');
            this.nbrCRCM = this.CRCMOrderByDate.length - 1;

            this.anneePremier = this.CRCMOrderByDate[this.nbrCRCM].date.split('/');
            this.AnneePremier = this.anneeDernier[2]
            this.AnneeDernier = this.anneePremier[2]

        }


    },

    methods: {
        filterListByKeyword: function(listeActualites){
            return listeActualites.filter(function(actu){
                return (
                    actu.titre.toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0
                    ? actu
                    : ''
                )
            }.bind(this))
        },

        ReiniFiltres: function(){
            this.keyword = '';
            this.dateMin = this.dateAncienneNum;
            this.dateMax = this.dateFutureNum;
            this.OrderActu = 'DateDecroissant';
        },

        filterActuByRange: function(listeActualites){
            return listeActualites.filter(actu => (
                actu.date_comparaison >= this.dateMin && actu.date_comparaison <= this.dateMax)
                ? actu
                : ''
            )
        },
    },

    filters : {
        liveSubstr: function(string, nb){
            return string.substring(0,nb) + '...';
        },
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Publications.vue